import {useEffect, useState} from 'react';

import {useTranslation} from 'react-i18next';

import {Box, Button, Grid, Typography} from '@mui/material';

import {RowValidationError} from './BatchInvitationsModal.types';

interface Props {
  generalErrors: string[];
  validationErrors: RowValidationError[];
}

export const BatchInvitationsValidationErrors = ({generalErrors, validationErrors}: Props) => {
  const {t: tr} = useTranslation('translation', {keyPrefix: 'screeningModule.batchInvitationsModal'});
  const rowErrorsPreviewLimit = 8;
  const [showAllRowErrors, setShowAllRowErrors] = useState(false);
  const hasMoreRowErrors = validationErrors.length > rowErrorsPreviewLimit;
  const visibleRowErrors = showAllRowErrors ? validationErrors : validationErrors.slice(0, rowErrorsPreviewLimit);

  useEffect(() => {
    setShowAllRowErrors(false);
  }, [validationErrors]);

  if (generalErrors.length === 0 && validationErrors.length === 0) {
    return null;
  }

  return (
    <Grid item xs={12}>
      {generalErrors.map((error) => (
        <Typography key={error} variant='body2' color='error' marginBottom={0.5}>
          {error}
        </Typography>
      ))}

      {validationErrors.length > 0 && (
        <Box
          sx={{
            marginTop: generalErrors.length > 0 ? '8px' : 0,
            border: '1px solid rgba(229, 57, 53, 0.35)',
            borderRadius: '8px',
            backgroundColor: 'rgba(229, 57, 53, 0.05)',
            padding: '12px',
          }}
        >
          <Typography variant='body2' color='error' sx={{fontWeight: 700}} marginBottom={1}>
            {tr('rowErrorsTitle', {count: validationErrors.length})}
          </Typography>

          <Box sx={{maxHeight: '180px', overflowY: 'auto', paddingRight: '4px'}}>
            {visibleRowErrors.map((error) => (
              <Typography key={error.row} variant='body2' color='error' marginBottom={0.5}>
                {tr('rowError', {row: error.row, errors: error.errors.join(', ')})}
              </Typography>
            ))}
          </Box>

          {hasMoreRowErrors && (
            <Grid
              container
              alignItems='center'
              justifyContent='space-between'
              sx={{marginTop: '6px', paddingTop: '8px', borderTop: '1px solid rgba(229, 57, 53, 0.2)'}}
            >
              <Typography variant='body2' color='error'>
                {tr('rowErrorsShowing', {
                  shownCount: visibleRowErrors.length,
                  totalCount: validationErrors.length,
                })}
              </Typography>
              <Button
                size='small'
                color='error'
                onClick={() => setShowAllRowErrors((prev) => !prev)}
                sx={{textTransform: 'none', minWidth: 'fit-content', padding: 0}}
              >
                {showAllRowErrors ? tr('rowErrorsShowLess') : tr('rowErrorsShowAll')}
              </Button>
            </Grid>
          )}
        </Box>
      )}
    </Grid>
  );
};
